import * as React from 'react';
import classnames from 'classnames';
import { Button, RichTextArea } from '@grandvisionhq/common';
import { Container, Heading } from '@grandvisionhq/elements';
import { Form, Email, Util } from '@grandvisionhq/forms';
import { Alert } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import { pushNewsletterEvent } from '../../data-layer/newsletter.js';

const NewsletterBanner = ({ backgroundColor , signupHeader , successHeader , consent , hasError , hasSubscribed , isLoading , onSubmit: submitForm  })=>{
    const { getLabel  } = useIntl();
    const onSubmit = (props)=>{
        var ref;
        const email = (ref = props.formState.email) === null || ref === void 0 ? void 0 : ref.value;
        if (!email) {
            return;
        }
        if (Util.validations.isEmailAddress(email)) {
            submitForm({
                email,
                mandateText: getLabel('account.optIn.newsletter')
            });
        }
    };
    const onHandleNewsletterEvent = ()=>{
        pushNewsletterEvent({
            interactionType: 'field_click'
        });
    };
    const classNames = classnames('newsletter-banner', {
        'newsletter-banner--grey': backgroundColor === 'grey',
        'newsletter-banner--white': backgroundColor === 'white'
    });
    const labels = {
        signUp: getLabel('common.newsletterSignUp.signUp'),
        emailAddress: getLabel('fields.input.email.label'),
        emailAddressErrorMessage: getLabel('account.error.emailInvalid'),
        generalErrorAlertMessage: getLabel('common.newsletterSignUp.error.generalAlertMessage'),
        generalErrorAlertTitle: getLabel('common.newsletterSignUp.error.generalAlertTitle')
    };
    return /*#__PURE__*/ React.createElement("section", {
        className: classNames,
        "aria-label": labels.signUp
    }, /*#__PURE__*/ React.createElement(Container, {
        className: "newsletter-banner__container"
    }, hasSubscribed ? /*#__PURE__*/ React.createElement(Heading, {
        variant: "small",
        className: "newsletter-banner__confirmation",
        role: "status",
        "aria-live": "polite"
    }, successHeader) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Heading, {
        variant: "small",
        className: "newsletter-banner__heading"
    }, signupHeader), /*#__PURE__*/ React.createElement("div", {
        className: "newsletter-banner__content"
    }, hasError ? /*#__PURE__*/ React.createElement(Alert, {
        variant: "error",
        notifyScreenReader: true,
        className: "alert-m-default"
    }, labels.generalErrorAlertMessage) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Form, {
        name: "newsletter-banner",
        className: "newsletter-banner__form",
        showErrorsOnInvalidSubmit: false,
        onSubmit: onSubmit,
        onBlur: onHandleNewsletterEvent
    }, /*#__PURE__*/ React.createElement(Email, {
        required: true,
        hideAsteriskSign: true,
        className: "newsletter-banner__input",
        placeholder: labels.emailAddress,
        errorMessage: labels.emailAddressErrorMessage,
        "aria-describedby": "consent"
    }), /*#__PURE__*/ React.createElement(Button, {
        className: "book-appointment__button",
        caption: labels.signUp,
        color: "primary",
        isLoading: isLoading,
        type: "submit"
    })), consent ? /*#__PURE__*/ React.createElement(RichTextArea, {
        id: "consent",
        className: "newsletter-banner__rich-text-area",
        content: consent
    }) : null)))));
};

export { NewsletterBanner as default };
//# sourceMappingURL=NewsletterBanner.js.map
